import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { GlobalChangesService } from "@shared/services/global-changes/global-changes.service";

/**
 * Síncrono a propósito: corre en cada navegación y no debe tocar la red.
 * El listener de `GlobalChangesService` corrige la decisión si el flag cambió.
 */
export const MaintenanceGuard: CanActivateFn = (): boolean | UrlTree => {
  const router: Router = inject(Router);
  const globalChangesService: GlobalChangesService = inject(GlobalChangesService);

  if (!globalChangesService.isMaintenanceModeCached()) return true;

  return router.createUrlTree(["/maintenance-mode"]);
};
